import { ArrowRight, BadgeCheck } from "lucide-react";
import { motion } from "framer-motion";
import { PAYMENT_URL } from "../lib/site";
import { Reveal, Eyebrow, CtaButton } from "./Reveal";

export default function Instructor() {
  return (
    <section id="instructor" data-testid="instructor-section" className="border-y border-[#E9DFFC]/60 bg-[#F6F1FF] py-20 sm:py-28">
      <div className="mx-auto grid max-w-6xl items-center gap-12 px-5 sm:px-8 lg:grid-cols-2 lg:gap-16">
        <Reveal className="relative mx-auto w-full max-w-md">
          <div className="absolute -inset-4 rounded-[2.5rem] bg-gradient-to-br from-[#9B5CF0]/30 via-transparent to-[#6D28D9]/30 blur-xl" />
          <div className="relative overflow-hidden rounded-[2rem] border-4 border-white shadow-[0_40px_80px_-30px_rgba(28,16,45,0.4)]">
            <img
              src="/instructor.webp"
              alt="Anuj Tiwari — Founder, Digital Product Academy"
              className="aspect-[4/4.6] w-full object-cover"
              loading="lazy"
              data-testid="instructor-photo"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-[#1C102D]/45 via-transparent to-transparent" />
            <div className="absolute bottom-4 left-4 right-4 flex items-center justify-between rounded-2xl bg-white/90 px-4 py-3 backdrop-blur-md">
              <div>
                <span className="block text-sm font-extrabold text-[#171321]">Anuj Tiwari</span>
                <span className="block text-[11px] font-semibold text-[#777181]">Founder — Digital Product Academy</span>
              </div>
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-gradient-to-br from-[#9B5CF0] to-[#6D28D9] text-white">
                <BadgeCheck size={17} />
              </span>
            </div>
          </div>
          <motion.div
            animate={{ y: [0, -10, 0] }}
            transition={{ duration: 5, repeat: Infinity, ease: "easeInOut" }}
            className="absolute -right-3 -top-4 rounded-2xl bg-[#1C102D] px-4 py-2.5 text-white shadow-[0_15px_35px_-10px_rgba(28,16,45,0.6)] sm:-right-6"
          >
            <span className="block text-[10px] font-bold uppercase tracking-widest text-[#C9B8F5]">Live Bootcamp</span>
            <span className="block text-sm font-extrabold">2 Days • Hinglish</span>
          </motion.div>
        </Reveal>

        <div>
          <Reveal>
            <Eyebrow testId="instructor-eyebrow">Your Instructor</Eyebrow>
          </Reveal>
          <Reveal delay={0.1}>
            <h2 className="mt-5 text-3xl font-extrabold leading-[1.12] tracking-tight text-[#171321] sm:text-4xl" data-testid="instructor-title">
              Learn With{" "}
              <span className="bg-gradient-to-r from-[#9B5CF0] to-[#6D28D9] bg-clip-text text-transparent">Anuj Tiwari.</span>
            </h2>
          </Reveal>
          <Reveal delay={0.18}>
            <p className="mt-3 font-mono text-xs font-bold uppercase tracking-[0.2em] text-[#7C3AED]">
              Founder — Digital Product Academy
            </p>
          </Reveal>
          <Reveal delay={0.26}>
            <p className="mt-5 max-w-lg text-base leading-relaxed text-[#777181] sm:text-lg">
              Practical live training focused on digital product creation, AI tools and online business fundamentals.
            </p>
          </Reveal>
          <Reveal delay={0.34}>
            <div className="mt-8">
              <CtaButton href={PAYMENT_URL} testId="instructor-cta">
                Learn With Me — ₹199 <ArrowRight size={17} strokeWidth={2.5} />
              </CtaButton>
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
}
